import React, {FC, useCallback} from 'react';
import styled from 'styled-components';

import {TeammateModel} from '../../../../../../libs/shared/core/src/models/api/teammateModel';
import {TimelineVariationsEnum} from '../../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {TeammateAvatar} from '../../../../../../libs/shared/ui/src/components/avatar/teammateAvatar';
import {ThreeDots} from '../../../../../../libs/shared/ui/src/components/composer/threeDots';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {TeammatesFormatter} from '../../../../common/formatters/teammatesFormatter';
import {CommentBase} from './commentBase';

/*
 * Props.
 */

interface CommentPrecogProps {
  teammates: ReadonlyArray<TeammateModel>;
  shouldHideTitle?: boolean;
  timelineVariation: TimelineVariationsEnum;
}

/*
 * Style.
 */

const StyledBubbleDiv = styled.div`
  padding: 12px 10px;
`;

/*
 * Component.
 */

export const CommentPrecog: FC<CommentPrecogProps> = (props) => {
  const theme = useUserTheme();
  // We need at least one teammate to render a precog.
  const {teammates, shouldHideTitle, timelineVariation} = props;
  if (teammates.length === 0) {
    throw new Error('The comment precog requires at least one teammate.');
  }

  const useRenderTitle = useCallback(() => <TeammatesFormatter teammates={teammates} />, [teammates]);
  const useRenderAvatar = useCallback(
    () => <TeammateAvatar teammate={teammates[0]} size={VisualSizesEnum.LARGE} />,
    [teammates],
  );

  return (
    <CommentBase
      shouldHideTitle={shouldHideTitle}
      renderTitle={useRenderTitle}
      renderAvatar={useRenderAvatar}
      wasJustPinned={false}
      wasJustHighlighted={false}
      isUnread
      timelineVariation={timelineVariation}
    >
      <StyledBubbleDiv>
        <ThreeDots color={theme.palette.blue.shade40} size={VisualSizesEnum.MEDIUM} />
      </StyledBubbleDiv>
    </CommentBase>
  );
};
